// MyRaai Luxe theme — Premium AI Command Center.
// Palette: White + Obsidian Black + Electric Blue + Dark Luxury Gold + Premium Pink.
export const luxe = {
  bg: '#FFFFFF',
  bgElev: '#FFFBE6',
  surface: '#FFFFFF',
  surface2: '#FFF4B8',
  border: '#E7DCA8',
  borderHi: '#7ADDDD',
  text: '#4B1727',
  textMid: '#5C4650',
  muted: '#76656B',
  // Electric Blue = AI / technology / active
  blue: '#16BDBD',
  blueBright: '#22CFC8',
  blueDeep: '#087F83',
  // Dark luxury gold = premium / enterprise
  gold: '#FFD900',
  goldSoft: '#FFE866',
  goldDark: '#9A7100',
  yellow: '#FFD900',
  amber: '#FFD900',
  // Premium pink = advanced / creative intelligence (accent only)
  pink: '#E83E8C',
  pinkBright: '#FF5BA8',
  // Obsidian
  obsidian: '#4B1727',
  deepBlack: '#4B1727',
  success: '#1B8F5A',
  warning: '#C99A18',
  danger: '#D64545',
  info: '#16BDBD',
};

export const PILLARS = {
  coding: {
    key: 'coding',
    name: 'Software Coding',
    short: 'Coding',
    tagline: '16 AI Coding Agents that build software',
    primary: '#16BDBD',
    accent: '#4B1727',
    grad: ['#39E2D6', '#16BDBD'],
    glow: 'rgba(22,189,189,0.42)',
    icon: 'Code2',
    path: '/coding',
  },
  marketing: {
    key: 'marketing',
    name: 'AI Marketing',
    short: 'Marketing',
    tagline: 'Campaigns, CRM, ROI analytics',
    primary: '#FFD900',
    accent: '#4B1727',
    grad: ['#FFE94A', '#FFD900'],
    glow: 'rgba(255,217,0,0.42)',
    icon: 'Megaphone',
    path: '/marketing',
  },
};

export const gradientCss = (arr) => `linear-gradient(135deg, ${arr.join(', ')})`;
